import ax from './axios';

export const confirmSMTPSettings = (token) => {
  return ax.post(`/rest/infrastructure/confirm-smtp-settings/${token}/`);
};
